import React from "react";

const ForresterSection = () => {
  return (
    <div className="column-sections pb-20">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="column-content pb-40">
            <div class="service_style_two_title pb-3 text-left">
                  <h4>What We Brought to the Table</h4>
            </div>
              <p className="text-left black">
              At the heart of our presence was the commitment to helping modern enterprises make faster, smarter, and more confident decisions. Our suite of solutions—engineered for marketing, sales, and revenue leaders—drew considerable attention from executives looking to:

              </p>
              <div class="col-md-12 col-lg-6 text-left">
            <div class="why-choose-icon  " data-wow-delay=".5">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check-lg"></i></span>
                <h6>Accelerate go-to-market strategies with actionable insights.
                </h6>
              </div>
            </div>
            <div class="why-choose-icon " data-wow-delay=".6">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>Optimize marketing ROI through enriched customer insights
                </h6>
              </div>
            </div>
            <div class="why-choose-icon" data-wow-delay=".7">
              <div class="choose-icon up">
                <span class="chose-icon1"> <i class="bi bi-check2"></i></span>
                <h6>And scale personalization with intelligence-led engagement.
                </h6>
              </div>
            </div>
            
          </div>
          <div class="service_style_two_title pt-4 text-left">
                  <h4>A Convergence of Leaders and Ideas
                  </h4>
            </div>
          <p className="text-left">The Forrester B2B Summit was more than a showcase, it was a convergence of strategy, innovation, and future-focused dialogue. We were privileged to interact with forward-thinking leaders across industries who shared their ambitions, challenges, and evolving priorities.
          </p>
          <div class="service_style_two_title pt-4 text-left">
                  <h4>What’s Next?
                  </h4>
            </div>
          <p className="text-left">As we reflect on the success of the Forrester B2B Summit, we remain energized and committed to leading the charge in data intelligence. With key insights gained and new partnerships forged, we’re moving ahead with sharper focus and deeper resolve.
          </p>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForresterSection;
